<template>
    <div class="problem">
      <p class="name">常见问题</p>
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item v-for="item in helpCenter" :key="item.id">
          <template slot="title">
            <div class="questions-and-answers">
              <img src="../../assets/img/icon13.png" alt="">
              <p>问答</p>
            </div>
            <p class="titles">{{ item.name }}</p>
          </template>
          <div class="text">{{ item.value }}</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </template>
  
  <script>
  import { getCommonList } from '../../api/userMG'
  export default {
    data() {
      return {
        helpCenter:[]
      }
    },
  
    created() {
      this.getHome();
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      async getHome(){
        // const loading = this.$loading({
        //   lock: true,
        //   text: '加载中',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // });
        await getCommonList({code:'cjwt'}).then(res => {
          // loading.close();
          console.log('数据',res);
          // 常见问题
          this.helpCenter = res.data
        })
        // .catch(err => {
        //   loading.close();
        // })
      }
    }
  }
  </script>
  
  <style scoped>
    .problem .name{
      font-family: SourceHanSansCN;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
      border-left: 3px solid #f15903;
      padding-left: 10px;
      margin-bottom: 20px;
    }
    .el-collapse{
      border: none;
    }
    .problem /deep/ .el-collapse-item{
      border: 1px solid #e8e8e8;
      margin-bottom: 20px;
      border-radius: 8px;
      padding: 10px 0;
      background: #fff;
    }
    .problem /deep/  .el-collapse-item__header{
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .problem /deep/ .el-collapse-item__header,.problem /deep/ .el-collapse-item__wrap{
      padding:0 20px;
      border: none;
    }
    .problem /deep/ .el-collapse-item__content{
      padding-bottom: 10px;
    }
    .questions-and-answers{
    width: 60px;
    height: 21px;
    border-radius: 30px;
    background: #fef2e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
  .questions-and-answers img{
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
  .questions-and-answers p{
    font-size: 10px;
    color: #f15903;
  }
  .titles{
    font-size: 15px;
    color: #333;
    font-weight: 600;
  }
  .problem .text{
    font-size: 13px;
    color: #7f7f7f;
  }
  .problem .is-active{
    box-shadow: 0px 9px 26px 1px #F3F3F5;
  }
  </style>
  
   
   
  
   


// WEBPACK FOOTER //
// src/views/support/course.vue